import { useCallback, useEffect, useState } from 'react'

import { useGlobalState } from '@/hooks/useGlobalState'
import { markBeforeYouStartPopupAsSeen, shouldShowBeforeYouStartPopup } from '@/utils/beforeYouStartPopup'

/**
 * Hook to manage the "Before you Start" popup state
 * Handles showing/hiding the popup and persisting the state to localStorage
 */
export function useBeforeYouStartPopup() {
  const { authenticationStore } = useGlobalState()
  const { isSponsorAdmin, isInSetup, user } = authenticationStore

  const [shouldShow, setShouldShow] = useState(false)

  // Check if popup should be shown when dependencies change
  useEffect(() => {
    const show = shouldShowBeforeYouStartPopup(isSponsorAdmin, isInSetup, user?.userId, user?.sponsorId)
    setShouldShow(show)
  }, [isSponsorAdmin, isInSetup, user?.userId, user?.sponsorId])

  const handleClose = useCallback(() => {
    if (user?.userId && user?.sponsorId) {
      const success = markBeforeYouStartPopupAsSeen(user.userId, user.sponsorId)
      if (success) {
        setShouldShow(false)
      }
    }
  }, [user?.userId, user?.sponsorId])

  const handleGetStarted = useCallback(() => {
    handleClose()
    // Additional logic can be added here if needed (e.g., navigate to first setup step)
  }, [handleClose])

  return {
    shouldShow,
    handleClose,
    handleGetStarted,
  }
}
